import { render, staticRenderFns } from "./icon-notification.vue?vue&type=template&id=0e9656ff&scoped=true&"
import script from "./icon-notification.vue?vue&type=script&lang=ts&"
export * from "./icon-notification.vue?vue&type=script&lang=ts&"
import style0 from "./icon-notification.vue?vue&type=style&index=0&id=0e9656ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9656ff",
  null
  
)

export default component.exports